import { IViewWidgetsHeader } from 'features/settings/editor/residents-editor/interfaces';

const TITLE_WIDGET_TYPES = ['header_title_widget', 'header_title_with_icon_widget'];

/**
 * Виджет с ФИ в шапке должен быть один (обычный или с иконкой-короной).
 * Из-за старого поведения короны (splice по индексу -1) он мог задвоиться,
 * затерев соседний виджет. Оставляем первый, остальные выкидываем.
 * */
const normalizeHeader = <T extends IViewWidgetsHeader>(header: T[]): T[] => {
  let hasTitle = false;

  return (header || []).filter((widget) => {
    if (!TITLE_WIDGET_TYPES.includes(widget?.type)) return true;
    if (hasTitle) return false;

    hasTitle = true;
    return true;
  });
};

export default normalizeHeader;
